<template>
  <div class="page">
    <div class="logo-container">
      <div class="logo">
        <img :src="require('@/image/logo.png')" alt="" />
      </div>
      <div class="title">沈阳工业气瓶溯源系统</div>
    </div>
    <!-- 表单 -->
    <van-form class="form" @submit="onSubmit">
      <div class="input-group">
        <!-- 用户名 -->
        <div class="van-hairline--bottom">
          <van-field
            v-model="phoneNumber"
            name="username"
            placeholder="用户名"
            :border="false"
            :rules="[{ required: true, message: '请填写用户名' }]"
          >
            <template #left-icon>
              <div class="left-icon">
                <img :src="require('@/image/user.png')" />
              </div>
            </template>
          </van-field>
        </div>
        <!-- 密码 -->
        <div class="van-hairline--bottom">
          <van-field
            v-model="password"
            type="password"
            name="password"
            placeholder="密码"
            autocomplete
            :rules="[{ required: true, message: '请填写密码' }]"
          >
            <template #left-icon>
              <div class="left-icon">
                <img :src="require('@/image/lock.png')" />
              </div>
            </template>
          </van-field>
        </div>
      </div>
      <div class="forgetDiv">
        <router-link to="/resetPassword">忘记密码</router-link>
      </div>
      <!-- 按钮 -->
      <div class="btns">
        <van-button
          block
          round
          type="primary"
          native-type="submit"
          :loading="loading"
          :disabled="loading"
          loading-text="登录中..."
        >
          登录
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { toRefs, reactive } from 'vue'
import useLogin, { state } from '@/hooks/useLogin' // 登录逻辑 loading onSubmit state
import base from '@/utils/base64'
export default {
  name: 'Login',
  setup() {
    const userInfo = reactive({
      phoneNumber: '',
      password: ''
    })
    const initUserInfo = () => {
      const username = localStorage.getItem('username')
      const password = localStorage.getItem('password')
      if (
        username !== '' &&
        username !== null &&
        password !== '' &&
        password !== null
      ) {
        userInfo.phoneNumber = base.decode(username)
        userInfo.password = base.decode(password)
      }
    }
    initUserInfo()
    return { ...useLogin, ...toRefs(state), initUserInfo, ...toRefs(userInfo) }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100vh;
  background-image: url('../../image/login_bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  .logo-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 180px;
    .title {
      padding-top: 5px;
      font-size: 18px;
      color: #1989fa;
      font-weight: 600;
    }
    img {
      width: 60px;
    }
  }
  .user-icon {
    text-align: left;
    font-size: 106px;
    color: #ccc;
    padding: 70px 20px 10px 50px;
  }
  .form {
    position: relative;
    top: 200px;
  }
  .input-group {
    margin: 0 60px;

    .left-icon {
      width: 30px;
      display: flex;
      align-items: center;
      img {
        width: 16px;
      }
    }
    .verification-button {
      font-size: 12px;
      border: 1px solid #1989fa;
      padding: 0 5px;
      border-radius: 5px;
      color: #1989fa;
    }
  }
  .btns {
    margin: 10px 100px 0px 80px;
    background: none;
  }
  .forgetDiv {
    text-align: right;
    margin-right: 60px;
    margin-top: 10px;
    font-size: 12px;
    background: none;
    a {
      color: #666;
    }
  }
}
::v-deep(.van-field) {
  background: none;
}
</style>
